module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEUAAAD/QAD/QBX/UBD/TQ3/SRL/Tg7/ThT/TRP/UBD/ThH/URD/UBT/UBP/UBL/TxL/ThH/URP/UBL/TxP/UBL/TxH/TxP/UBL/UBL/TxP/TxL/UBL/TxL/UBP/UBP/TxL/TxP/UBP/UBP/TxP/UBP/UBL/TxL/TxP/UBL/TxP/TxP/UBL/UBP/TxP/TxL/UBL/UBP/TxL/UBMLOjKuAAAAMnRSTlMABAwQFBwkJygwOz9AQ1NXW19ja293e3+Dh4uPm5+jq6uvs7u/w8fH09fb3+Pn6+/z+42XADcAAACJSURBVBgZBcGNIsJQAAbQc7MR+Rspo4kspND93v/hnAOYXp4DAE8ZAYBlRgBgmQ0AcJ8B4HF1gS4Dpv2aQ/L90HYZJncfSVqLbZK6z/6YZNe3aLrXY5L6Pj8FMKvJHADtT1a1zgBMvvJmkd8zQNnk0Cjb7E6A59QrtH8ZC5SX9OA6nw1wW4Cbgn8UqA5ftiPkxAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xing.png
// module id = QGyD
// module chunks = 1